/* global localData, validateEmailInput */
if (document.querySelector('.contact-module')) {
  const contactForms = (() => {
    const r = {
      button: document.querySelector('.contact-module .btn'),
      contactForm: document.querySelector('.contact-module form'),
      loadingHtml: document.querySelector('.loading'),
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        r.contactForm.querySelectorAll('input, textarea').forEach((input) => {
          const type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
          switch (type) {
            case 'TEXTAREA':
            case 'hidden':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!formData[input.name]) {
                  input.closest('.mod-input').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('.mod-input').classList.remove('is-validation-failed');
                }
              }
              break;
            case 'checkbox':
              formData[input.name] = input.checked;
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.parentNode.classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.parentNode.classList.remove('is-validation-failed');
              }
              break;
            case 'radio':
              if (!formData[input.name]) {
                formData[input.name] = r.getRadioValue(input.closest('.radio-button, .dropdown'));
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!validateEmailInput(formData[input.name])) {
                  input.closest('.mod-input').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('.mod-input').classList.remove('is-validation-failed');
                }
              }
              break;
            default:
          }
        });
        if (r.isValid) {
          r.loadingHtml.classList.add('is-active');
          const ajax = new XMLHttpRequest();
          const formDataImage = new FormData();
          formDataImage.append('action', formData.action);
          formDataImage.append('inputs', JSON.stringify(formData));
          formDataImage.append('lang', localData.lang);
          formDataImage.append('id', localData.id);
          formDataImage.append('nonce', formData.nonce);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            const parentContactElem = r.contactForm.closest('.contact-module');
            if (ajax.status === 200 && response.data.url) {
              window.location = response.data.url;
            } else if (ajax.status === 200 && response.data.msg) {
              if (response.data.type === 'contact') {
                parentContactElem.classList.add('is-sent');
                r.contactForm.style.display = 'none';
                r.contactForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }
            document.querySelectorAll('.mod-input').forEach((item) => {
              item.classList.remove('is-focused');
            });
            document.querySelectorAll('.dropdown__placeholder').forEach((item) => {
              // eslint-disable-next-line no-param-reassign
              item.innerHTML = '';
            });
            r.contactForm.reset();
            r.loadingHtml.classList.remove('is-active');
          };
          ajax.send(formDataImage);
        }
      },
      getRadioValue: (radio) => {
        let data = '';
        radio.querySelectorAll('input').forEach((item) => {
          if (item.checked) {
            data = item.value;
          }
        });
        return data;
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  contactForms.initialize();
}
